import { useRef, useEffect } from 'react';

function useClickOutside(onClick, deps) {
  var nodeRef = useRef(null); // Handle the click event, and determine if it was within the target ref

  var handleClickAnywhere = function handleClickAnywhere(e) {
    if (e.target instanceof Element && nodeRef.current && nodeRef.current.contains(e.target)) {
      return;
    }

    onClick(e);
  }; // Listen to clicks anywhere in the document


  useEffect(function () {
    document.addEventListener('mousedown', handleClickAnywhere);
    return function () {
      document.removeEventListener('mousedown', handleClickAnywhere);
    };
  }, deps);
  return nodeRef;
}

export default useClickOutside;
//# sourceMappingURL=useClickOutside.js.map
